module.exports = __webpack_public_path__ + "static/media/logo14.82b630d3.jpg";